export default "__VITE_ASSET__B7OAh2Dp__"